import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { StepOneFormMessages as messages } from './StepOneForm.i18n';
import * as form from './StepOneFormInputs';
import { SharedMessages as sharedMsgs } from '../../shared/sharedMessages.i18n';

export class StepOneForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
    };
  }

  handleOnSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const errors = form.validate(event.target);
    if (Object.keys(errors).length !== 0) {
      this.setState({
        errors,
      });
      return;
    }

    if (this.props.onSubmit) {
      this.props.onSubmit(event);
    }
  }

  handleOnChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    const newErrorState = this.state.errors ?
      Object.assign({},
        this.state.errors,
        {
          [name]: '',
        }) : {};

    this.setState({
      [name]: value,
      errors: newErrorState,
    });
  }

  renderRegistrationIdentifier() {
    const { patientIdentifierLabel } = this.props;

    let formInputs = [
      {
        id: 'PIN',
        labelText: <FormattedMessage { ...messages.form.pin.label } />,
        type: 'text',
        helpText: <FormattedMessage { ...messages.form.pin.help } />,
        value: this.state.PIN,
        error: this.state.errors.PIN,
        autocomplete: 'off',
        onChange: this.handleOnChange,
        onKeyPress: form.handleKeyPress([form.numericCharactersOnly]),
        mdSize: 4,
        xsSize: 6,
      },
      {
        id: 'MRN',
        labelText: patientIdentifierLabel || '',
        type: 'text',
        helpText: <FormattedMessage { ...messages.form.mrn.help } />,
        value: this.state.MRN,
        error: this.state.errors.MRN,
        autocomplete: 'off',
        onChange: this.handleOnChange,
        mdSize: 4,
        xsSize: 6,
      },
      {
        id: 'SSN',
        labelText: <FormattedMessage { ...messages.form.ssn.label } />,
        type: 'text',
        value: this.state.SSN,
        error: this.state.errors.SSN,
        autocomplete: 'off',
        onChange: this.handleOnChange,
        onKeyPress: form.handleKeyPress([form.numericCharactersOnly]),
        mdSize: 4,
        xsSize: 6,
      },
    ];

    if (this.props.signUpCapability && this.props.signUpCapability.details) {
      const fieldNames = this.props.signUpCapability.details.map(item => item.fieldName.toLowerCase());
      formInputs = formInputs.filter(formInput => fieldNames.indexOf(formInput.id.toLowerCase()) > -1);
    }

    return (
      <div>
        { formInputs.map(formAttribs =>
          (
            form.StepOneInputFieldBlock(formAttribs)
          ))}
      </div>
    );
  }

  render() {
    return (
      <form onSubmit={this.handleOnSubmit}>
        { form.StepOneInputFieldBlock(
          {
            id: 'FirstName',
            labelText: <FormattedMessage { ...messages.form.firstname } />,
            type: 'text',
            value: this.state.FirstName,
            error: this.state.errors.FirstName,
            onChange: this.handleOnChange,
          })
        }

        { form.StepOneInputFieldBlock(
          {
            id: 'LastName',
            labelText: <FormattedMessage { ...messages.form.lastname } />,
            type: 'text',
            value: this.state.LastName,
            error: this.state.errors.LastName,
            onChange: this.handleOnChange,
          })
        }

        { form.DobBlock(
          [
            { id: 'DobDay',
              maxLength: '2',
              helpText: <FormattedMessage {...messages.form.dob.help.dd} />,
              helpDescription: <FormattedMessage {...messages.form.dob.help.day} />,
              className: 'dob day',
              autocomplete: 'off',
              value: this.state.DobDay,
              error: this.state.errors.DobDay,
              onChange: this.handleOnChange,
              onKeyPress: form.handleKeyPress([form.numericCharactersOnly, form.lessThanOrEqual(31)]),
            },
            { id: 'DobMonth',
              maxLength: '2',
              helpText: <FormattedMessage {...messages.form.dob.help.mm} />,
              helpDescription: <FormattedMessage {...messages.form.dob.help.month} />,
              className: 'dob month',
              autocomplete: 'off',
              value: this.state.DobMonth,
              error: this.state.errors.DobMonth,
              onChange: this.handleOnChange,
              onKeyPress: form.handleKeyPress([form.numericCharactersOnly, form.lessThanOrEqual(12)]),
            },
            { id: 'DobYear',
              maxLength: '4',
              helpText: <FormattedMessage {...messages.form.dob.help.yyyy} />,
              helpDescription: <FormattedMessage {...messages.form.dob.help.year} />,
              className: 'dob year',
              autocomplete: 'off',
              value: this.state.DobYear,
              error: this.state.errors.DobYear,
              onChange: this.handleOnChange,
              onKeyPress: form.handleKeyPress([form.numericCharactersOnly]),
            },
          ]) }

        {this.renderRegistrationIdentifier()}

        <div className="spacer medium"></div>
        <button
          data-qa-item="next_signup_step1"
          data-toggle="modal"
          data-target="#next"
          className="btn btn-lg btn-primary"
          href="signup2.html"
          aria-describedby="label_openNewScreen"
        >
          <FormattedMessage { ...messages.form.button.next } />
        </button>
        <span className="sr-only" id="label_openNewScreen">
          <FormattedMessage { ...sharedMsgs.labels.openNewScreen } />
        </span>
        &nbsp;&nbsp;
        <button
          data-qa-item="cancel_signup_step1"
          data-toggle="modal"
          data-target="#confirmCancel"
          className="btn btn-lg btn-link"
          onClick={this.props.onClickCancel}
          aria-describedby="label_openNewDialog"
        >
          <FormattedMessage { ...messages.form.button.cancel } />
        </button>
        <span className="sr-only" id="label_openNewDialog">
          <FormattedMessage { ...sharedMsgs.labels.openNewDialog } />
        </span>
        <div className="spacer medium"></div>
      </form>
    );
  }
}

StepOneForm.propTypes = {
  onClickCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  signUpCapability: PropTypes.object,
  patientIdentifierLabel: PropTypes.string,
};
